"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.polycat = void 0;
exports.polycat = {
    masterchef: "0x8CFD1B9B7478E7B0422916B72d1DB6A9D513D734",
};
